import { Icon } from "@iconify/react";
import { useMutation, useQueries, useQuery } from "@tanstack/react-query";
import exportToExcel from "Components/CommonComponents/ExcelDownload";
import PageLoader from "Components/PageLoader";
import CustomerTable from "Components/support/customervendor/customer";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  fetchAllCategories,
  fetchAllPurities,
  fetchAllStockReport,
  fetchAllStockReportByDesign,
  fetchAllStockReportByProduct,
} from "services/generalService";
import Skeleton from "UIComp/Skeleton";
import { reportsByDesign, reportsByProduct } from "utils/helpers";
const defaultData = {
  category: "1",
  purity: "",
  product: "",
  design: "",
  fromDate: new Date().toISOString().split("T")[0],
  toDate: new Date().toISOString().split("T")[0],
};
const Design = ({
  allCategories,
  allPurities,
  allProducts,
  allDesigns,
  clientCode,
  style,
}) => {
  const {
    data: allStockReport,
    isError: allStockReportIsError,
    isPending: allStockReportIsLoading,
    mutate,
  } = useMutation({ mutationFn: fetchAllStockReportByDesign });

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: defaultData });

  const stockType = watch("stockType");
  const category = watch("category");
  const purity = watch("purity");
  const fromDate = watch("fromDate");
  const toDate = watch("toDate");
  const product = watch("product");
  const design = watch("design");

  const purityList = useMemo(() => {
    if (allPurities?.length && category) {
      const result = allPurities?.filter(
        (item) => item?.CategoryId == category
      );
      return result;
    }
  }, [allPurities, category]);

  const productList = useMemo(() => {
    if (allProducts?.length && category) {
      const result = allProducts?.filter(
        (item) => item?.CategoryId == category
      );
      return result;
    }
  }, [allProducts, category]);

  const designList = useMemo(() => {
    if (allDesigns?.length && category) {
      const result = allDesigns?.filter(
        (item) => item?.CategoryId == category && item?.ProductId == product
      );
      return result;
    }
  }, [allDesigns, category, product]);

  useLayoutEffect(() => {
    mutate({
      ClientCode: clientCode,
      FromDate: fromDate,
      ToDate: toDate,
      StockType: stockType,
      PurityId: +(purity || 0),
      CategoryId: +(category || 0),
      ProductId: +(product || 0),
      ProductId: +(product || 0),
      DesignId: +(design || 0),
    });

    console.log(design)
  }, [purity, fromDate, toDate, stockType,category, product,design]);


  const sum = useMemo(()=>{
    if(allStockReport?.length){
      let total = {
        OpeningQuantity:0,
        OpeningGrossWeight:0,
        OpeningNetWeight:0,
        StockEntryQuantity:0,
        StockEntryGrWt:0,
        SaleQty:0,
        SaleGrossWt:0,
        ClosingQty:0,
        ClosingGrossWeight:0,
        ClosingNetWeight:0,
      }
        allStockReport?.forEach((item)=>{
        total.OpeningQuantity += +(item?.OpeningQuantity || 0)
        total.OpeningGrossWeight += +(item?.OpeningGrossWeight || 0)
        total.OpeningNetWeight += +(item?.OpeningNetWeight || 0)
        total.StockEntryQuantity += +(item?.StockEntryQuantity || 0)
        total.StockEntryGrWt += +(item?.StockEntryGrWt || 0)
        total.SaleQty += +(item?.SaleQty || 0)
        total.SaleGrossWt += +(item?.SaleGrossWt || 0)
        total.ClosingQty += +(item?.ClosingQty || 0)
        total.ClosingGrossWeight += +(item?.ClosingGrossWeight || 0)
        total.ClosingNetWeight += +(item?.ClosingNetWeight || 0)
      })
     Object?.keys(total)?.map((item)=>{
      total[item] = (total[item] || 0)?.toFixed(2)
     }) 
      return {
        serialNumber:"Total",
        ...total
      }
    }
  },[allStockReport])

  const DownloadExcel = (data)=>{
    const headers = {
      'S.No': null, // Auto-generated
      'Design': 'Design',
      'Opening Qty': 'OpeningQuantity',
      'Opening Gr Wt': 'OpeningGrossWeight',
      'Opening Net Wt': 'OpeningNetWeight',
      'Stock In Qty': 'StockEntryQuantity',
      'Stock In Gr Wt': 'StockEntryGrWt',
      'Sale Qty': 'SaleQty',
      'Sale Gross Wt': 'SaleGrossWt',
      'Closing Qty': 'ClosingQty',
      'Closing Gr Wt': 'ClosingGrossWeight',
      'Closing Net Wt': 'ClosingNetWeight',
     
    };
    exportToExcel(data, headers, 'StockDesignReport.xlsx',true);
  }
  return (
    <>
      <div style={{ margin: "20px 0px" }}>
        <div>
          <div className={style.filterBox}>
            {/* Stock Type */}
            <div className={style.inputContainer}>
              <label htmlFor="stockType" className={style.inputLabel}>
                Stock Type
              </label>
              <select
                className={style["input-selects"]}
                id="stockType"
                {...register("stockType")}
              >
                <option value="">Stock Type</option>
                <option value="Labelled Stock">Labelled</option>
                <option value="Unlabelled Stock">Unlabelled</option>
              </select>
            </div>

            {/* Category */}
            <div className={style.inputContainer}>
              <label htmlFor="category" className={style.inputLabel}>
                Category
              </label>
              <select
                className={style["input-selects"]}
                id="category"
                {...register("category")}
              >
                <option value="">Select Category</option>
                {allCategories?.length
                  ? allCategories?.map((x) => (
                      <option key={x.Id} value={`${x.Id}`}>
                        {x.CategoryName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* Product */}
            <div className={style.inputContainer}>
              <label htmlFor="product" className={style.inputLabel}>
                Product
              </label>
              <select
                className={style["input-selects"]}
                id="product"
                {...register("product")}
              >
                <option value="">Select Product</option>
                {productList?.length
                  ? productList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.ProductName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* Design */}
            {/* <div className={style.inputContainer}>
              <label htmlFor="design" className={style.inputLabel}>
                Design
              </label>
              <select
                className={style["input-selects"]}
                id="design"
                {...register("design")}
              >
                <option value="">-- select --</option>
                {designList?.length
                  ? designList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.DesignName}
                      </option>
                    ))
                  : []}
              </select>
            </div> */}

            {/* Purity */}
            <div className={style.inputContainer}>
              <label htmlFor="purity" className={style.inputLabel}>
                Purity
              </label>
              <select
                className={style["input-selects"]}
                id="purity"
                {...register("purity")}
              >
                <option value="">-- select --</option>
                {purityList?.length
                  ? purityList?.map((x) => (
                      <option key={x?.Id} value={`${x?.Id}`}>
                        {x?.PurityName}
                      </option>
                    ))
                  : []}
              </select>
            </div>

            {/* From Date */}
            <div className={style.inputContainer}>
              <label htmlFor="fromDate" className={style.inputLabel}>
                From Date
              </label>
              <input
                className={style["input-selects"]}
                type="date"
                id="fromDate"
                style={{ border: "1px solid #ccc",padding:"5px 0px"  }}
                placeholder="From Date"
                max={new Date().toISOString().split("T")[0]}
                {...register("fromDate")}
              />
            </div>

            <div className={style.inputContainer}>
              <label htmlFor="toDate" className={style.inputLabel}>
                To Date
              </label>
              <input
                className={style["input-selects"]}
                type="date"
                id="toDate"
                style={{ border: "1px solid #ccc",padding:"5px 0px"  }}
                placeholder="To Date"
                max={new Date().toISOString().split("T")[0]}
                min={fromDate || ""}
                {...register("toDate")}
              />
            </div>

            {/* Reset Button */}
            <div className={style.buttonContainer}>
              <button
                className={style["two-buttons"]}
                style={{
                  backgroundColor: "#fff",
                  color: "#0077d4",
                  border: "1px solid #0077d4",
                  padding: "10px 10px",
                }}
                onClick={() => reset()}
              >
                <Icon icon="ix:reset" width="24" height="512" />
                Reset
              </button>

              {/* Print Button */}
              <button
                className={style["two-buttons"]}
                style={{
                  color: "#fff",
                  cursor: "pointer",
                  padding: "11px 10px",
                }}
                // onClick={() => printStockList()}
                onClick={() => DownloadExcel([...allStockReport,sum])}
              >
                <Icon icon="ic:outline-print" width="20" height="20" />
                Print List
              </button>
            </div>
          </div>
        </div>
      </div>
      {allStockReportIsLoading ? (
        <Skeleton />
      ) : (
        <CustomerTable
          columns={reportsByDesign}
          allCategories={allStockReport?.length ? allStockReport : []}
          searchInput={""}
          setSearchInput={() => {}}
          showActionButton={false}
          showSum={true}
          sum={sum}
        />
      )}
    </>
  );
};

export default Design;
